module.exports = __webpack_public_path__ + "img/7.0d35076c.png";